








const positionSuggestions = ({ state, props }) => {
  if (state.isActive && props.suggestions.length > 0) {
    return {
      transform: 'scaleY(1)',
      transition: 'all 0.25s cubic-bezier(.3,1.2,.2,1)'
    };
  }

  if (state.isActive) {
    return {
      transform: 'scaleY(0)',
      transition: 'all 0.25s cubic-bezier(.3,1,.2,1)'
    };
  }

  return {};
};

export default positionSuggestions;